<template>
  <div>
    <h4 class="title">
      برنامه اتاق جلسات
    </h4>
    <b-overlay :show="calendarProgress">
      <persian-calendar
          :events-list="events"
          :display-period.sync="period"
          :min-date="min"
          disable-past-days
          class="cursor-pointer"
          @on-day-click="onDayClick"
      >

        <template
            slot="event"
            slot-scope="i"
        >
          <div
              :key="i.value.id"
              style="padding: 5px;"
              :class="i.value.classes"
              :style="`top:${i.top};background-color:${i.value.color};`"
              class="vpc_event"
              @click="onEventClick(i.value)"
          >
            <!--  Anything You Wish -->
            <span
                class="vpc_event-title"
                style="padding: 5px!important"
                :class="i.value.classes"
            >
              {{ i.value.title }}
            </span>
          </div>
        </template>
      </persian-calendar>
    </b-overlay>
    <b-modal
        v-model="showModal"
        centered
        :title="`درخواست اتاق های (${menuTitle})`"
        size="lg"
        :no-close-on-backdrop="true"
        hide-footer
    >
      <b-overlay :show="onProgress">
        <b-table
            :fields="fields"
            :items="items"
            hover
            striped
            responsive
        >
          <template #table-busy>
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle"/>
              <strong> درحال دریافت اطلاعات...</strong>
            </div>
          </template>

          <template #cell(isActive)="data">
            <b-avatar
                :id="`user-row-${data.item.id}`"
                size="32"
                :variant="data.value ? 'light-success': 'light-danger'"
            >
              <feather-icon
                  :icon="data.value ? 'CheckIcon': 'XIcon'"
              />
            </b-avatar>
          </template>
          <template #cell(action)="data">

            <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      class="btn-icon rounded-circle"
                      @click="getDetail(data.item.id)"
            >
              <feather-icon
                  icon="EyeIcon"
                  class="text-primary"
              />
            </b-button>
          </template>

        </b-table>
      </b-overlay>
    </b-modal>
    <b-modal
        ref="submitProject"
        v-model="showDetail"
        ok-title="بستن"
        ok-only
        centered
        size="lg"
    >
      <dl v-if="showDetail && detail">
        <dt ><b>نام اتاق</b></dt>
        <dd >{{ detail.room ? detail.room.name : 'فرقی ندارد'  }}</dd>
        <dt><b>تاریخ رزرو</b></dt>
        <dd><bdi>{{ detail.start_at_jalali }} الی {{ detail.end_at_jalali }}</bdi></dd>
        <dt><b>وضعیت</b></dt>
        <dd><b-badge
            :variant="detail.status.label"
            class="mr-1"
        >
          {{ detail.status.title }}
        </b-badge>
        </dd>
        <dt v-if="detail.description"><b>توضیحات</b></dt>
        <dd v-if="detail.description" v-html="detail.description"></dd>
        <dt><b>تاریخ درخواست</b></dt>
        <dd>
          {{ detail.createdAt }}
        </dd>
        <dt v-if="detail.action_at"><b>تاریخ رد/تأیید</b></dt>
        <dd>
          {{ detail.action_at }}
        </dd>
        <dt v-if="detail.admin_description"><b>توضیحات مدیر</b></dt>
        <dd v-html="detail.admin_description"></dd>
      </dl>
    </b-modal>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend, BFormInvalidFeedback, BFormCheckbox, BModal, BTabs, BTab, BButton,
  BTable, BDropdownItem, BAvatar, BBadge, BSpinner, BDropdown,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import ripple from 'vue-ripple-directive'
import PersianCalendar from '@/views/components/reservation/PersianCalendar.vue'
import {parsMomentEvent, parsMomentWithTimeEvent, PersianNowDate} from '@/libs/utils'
import {ValidationProvider} from "vee-validate";

export default {
  name: 'RoomReservationList',
  components: {
    ValidationProvider,
    BDropdown,
    BSpinner,
    BBadge,
    BAvatar,
    BDropdownItem,
    BTab,
    BTabs,
    BFormCheckbox,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    VSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    PersianCalendar,
    BButton,
    BTable,
  },
  directives: {
    ripple,
  },
  data() {
    return {
      onProgress: false,
      calendarProgress: false,
      showModal: false,
      period: 'week',
      min: this.$moment(new Date(), 'jYYYY/jMM/jDD'),
      events: [],
      selectedDay: null,
      menuTitle: '',
      fields: [
        {
          key: 'room.name',
          label: 'نام اتاق',
        },
        {
          key: 'startAt',
          label: 'ساعت شروع',
        },
        {
          key: 'endAt',
          label: 'ساعت پایان',
        },
        {
          key: 'creator.name',
          label: 'درخواست دهنده',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      showDetail: false,
      detail:{}
    }
  },
  mounted() {
    this.getEvents()
  },
  methods: {
    async getEvents() {
      this.calendarProgress = true
      await this.$http.get('room-reservations/time-sheet')
          .then(({data}) => {
            if (data.status) {
              // this.events = data.reservations
              this.events = data.reservations.map(event => parsMomentWithTimeEvent(event, this.$moment))
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت زمان اتاق جلسات با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? error.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })

      this.calendarProgress = false
    },
    getDetail(id){
      this.$http.get(`room-reservations/${id}`)
          .then(({ data }) => {
            if (data.status) {
              this.detail = data.reservation
              this.showDetail = true
            } else {
              this.$bvToast.toast(data.message ?? 'در دریافت جزییات رزرو اتاق جلسات خطایی رخ داده', {
                title: 'حطا',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })

    },

    nextPage(event) {
      // console.log(event.format())
    },
    onEventClick(e) {
      this.onDayClick(this.$moment(e.startDateTime))
    },
    onDayClick(event) {
      this.showModal = true
      this.selectedDay = event
      this.menuTitle = event.format('jDD jMMMM jYYYY')
      this.getDayMenu()
    },
    getDayMenu() {
      this.onProgress = true
      this.$http.get(`room-reservation-by-date/${PersianNowDate(this.selectedDay, false, true)}`)
          .then(({data}) => {
            if (data.status) {
              this.items = data.reservations
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? error.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>

<style>

</style>
